var state = {
    deliveryAddress: null,
    paymentMethod: null,
    serviceType: null,
    orderTime: null,
    preorder: 0,
    orderInFlight: false,
    userInstructions: '',
    userSetServiceType: false,
    isGuest: false,
    guestId: null,
    offerFlag: '',
    leaveAtDoor: false,
};
var getters = {
    getPaymentMethod: function (state) {
        return state.paymentMethod;
    },
    getDeliveryAddress: function (state) {
        return state.deliveryAddress;
    },
    getServiceType: function (state) {
        return state.serviceType;
    },
    getOrderTime: function (state) {
        return state.orderTime;
    },
    getPreorder: function (state) {
        return state.preorder;
    },
    getOrderInFlight: function (state) { return state.orderInFlight; },
    getUserInstructions: function (state) { return state.userInstructions; },
    getUserSetServiceType: function (state) { return state.userSetServiceType; },
    getIsGuest: function (state) { return state.isGuest; },
    getGuestId: function (state) { return state.guestId; },
    getOfferFlag: function (state) { return state.offerFlag; },
    getLeaveAtDoor: function (state) { return state.leaveAtDoor; },
};
var actions = {
    setPaymentMethod: function (_a, paymentMethod) {
        var commit = _a.commit;
        commit("setPaymentMethod", paymentMethod);
    },
    setDeliveryAddress: function (_a, deliveryAddress) {
        var commit = _a.commit;
        commit("setDeliveryAddress", deliveryAddress);
    },
    setServiceType: function (_a, serviceType) {
        var commit = _a.commit;
        commit("setServiceType", serviceType);
    },
    setOrderTime: function (_a, orderTime) {
        var commit = _a.commit;
        commit("setOrderTime", orderTime);
    },
    setPreorder: function (_a, preorder) {
        var commit = _a.commit;
        commit("setPreorder", preorder);
    },
    setOrderInFlight: function (_a, orderInFlight) {
        var commit = _a.commit;
        commit('setOrderInFlight', orderInFlight);
    },
    setUserInstructions: function (_a, instructions) {
        var commit = _a.commit;
        commit('setUserInstructions', instructions);
    },
    setUserSetServiceType: function (_a, userSetServiceType) {
        var commit = _a.commit;
        commit('setUserSetServiceType', userSetServiceType);
    },
    setIsGuest: function (_a, isGuest) {
        var commit = _a.commit;
        commit('setIsGuest', isGuest);
    },
    setGuestId: function (_a, guestId) {
        var commit = _a.commit;
        commit('setGuestId', guestId);
    },
    setOfferFlag: function (_a, offerId) {
        var commit = _a.commit;
        commit('setOfferFlag', offerId);
    },
    setLeaveAtDoor: function (_a, leaveAtDoor) {
        var commit = _a.commit;
        commit('setLeaveAtDoor', leaveAtDoor);
    }
};
var mutations = {
    setPaymentMethod: function (state, paymentMethod) {
        state.paymentMethod = paymentMethod;
    },
    setDeliveryAddress: function (state, deliveryAddress) {
        state.deliveryAddress = deliveryAddress;
    },
    setServiceType: function (state, serviceType) {
        state.serviceType = serviceType;
    },
    setOrderTime: function (state, orderTime) {
        orderTime.set({ seconds: 0, millisecond: 0 });
        state.orderTime = orderTime;
    },
    setPreorder: function (state, preorder) {
        state.preorder = preorder;
    },
    setOrderInFlight: function (state, orderInFlight) {
        state.orderInFlight = orderInFlight;
    },
    setUserInstructions: function (state, userInstructions) {
        state.userInstructions = userInstructions;
    },
    setUserSetServiceType: function (state, userSetServiceType) {
        state.userSetServiceType = userSetServiceType;
    },
    setIsGuest: function (state, isGuest) {
        state.isGuest = isGuest;
    },
    setGuestId: function (state, guestId) {
        state.guestId = guestId;
    },
    setOfferFlag: function (state, offerId) {
        state.offerFlag = offerId;
    },
    setLeaveAtDoor: function (state, leaveAtDoor) {
        state.leaveAtDoor = leaveAtDoor;
    },
};
export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations
};



//////////////////
// WEBPACK FOOTER
// ./src/stores/modules/account.checkout.store.ts
// module id = null
// module chunks = 